import React from 'react';
import {useNavigate} from "react-router-dom";

const MycorpLogin = () => {
    const navigate = useNavigate()
    const goToLogin = () => navigate('/login')
    return (
        <div className='corp_login_container'>
            <div className='inner_container'>
                <p className='title_sm'>
                    뉴스가 궁금한 기업이 있나요? <br/>
                    로그인 후 이용해 주세요!
                </p>
                <button className='login_btn' onClick={goToLogin}>로그인 하러가기</button>
            </div>
        </div>

    );
};

export default MycorpLogin;